// extracted by mini-css-extract-plugin
module.exports = {"vasCardOuter":"_2uRxt","cardTitle":"_1MUGI","activeCard":"FUV7B","boldFont":"_36KiD","saveAmount":"_2CUl5","display":"_1Ioab"};